module.exports = __webpack_public_path__ + "static/img/image (4).39bb538f.png";